import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import {
  Modal,
  Button,
  Grid,
  Axios,
  List,
  notice,
  Segment,
} from 'component/base'
import { Custom } from 'component/pieces'

export const GyomuGoTenkoKirokuModal = props => {
  const {
    isOpenModal,
    onClickCancel,
    kumiaiin_id,
    id,
    gyomuGoId,
  } = props

  const [data, setData] = useState({})
  const [loading, setLoading] = useState(false)

  const BASE_PATH = `/api/staff/kumiaiin/${kumiaiin_id}/tenko_kiroku/${id}/gyomu_go_tenko_kiroku/${gyomuGoId}`

  useEffect(() => {
    if(isOpenModal){
      callGetApi()
    }
  }, [isOpenModal])

  const callGetApi = async () => {
    setLoading(true)
    const { data, error } = await Axios.ajax.get(`${BASE_PATH}`)
    if (error){
      notice({
        title: 'Error',
        description: '業務後点呼記録データの取得に失敗しました',
        type: 'error',
      })
      setLoading(false)
      return
    }
    setLoading(false)
    setData(data)
  }

  return (
    <>
      <Modal
        closeOnEscape={true}
        closeOnDimmerClick={true}
        onClose={onClickCancel}
        open={isOpenModal}
      >
        <Modal.Header>業務後点呼記録</Modal.Header>
        <Segment loading={loading}>
        <Modal.Content>
            <Custom.Divider.Segment content='点呼記録' />
              <Custom.Modal.TenkoKiroku data={data} />
            <Custom.Divider.Segment content='業務後点呼記録' />
            <Grid>
                <Grid.Row>
                    <Grid.Column>
                        <List divided relaxed>
                            <List.Item>
                                <List.Content>
                                <List.Header style={{ marginBottom: '0.3em' }}>実施時刻</List.Header>
                                {`${data.time}`}
                                </List.Content>
                            </List.Item>
                            <List.Item>
                                <List.Content>
                                <List.Header style={{ marginBottom: '0.3em' }}>点呼方法</List.Header>
                                {`${data.tenko_type_kbn === 'taimen' ? '対面' : 'その他'}`}
                                </List.Content>
                            </List.Item>
                            {data.tenko_type_sonota && (
                            <List.Item>
                                <List.Content>
                                <List.Header style={{ marginBottom: '0.3em' }}>点呼方法（その他）</List.Header>
                                {`${data.tenko_type_sonota}`}
                                </List.Content>
                            </List.Item>
                            )}
                            <List.Item>
                                <List.Content>
                                <List.Header style={{ marginBottom: '0.3em' }}>点呼執行者</List.Header>
                                {`${data.tenko_shikkosha}`}
                                </List.Content>
                            </List.Item>
                            <List.Item>
                                <List.Content>
                                <List.Header style={{ marginBottom: '0.3em' }}>アルコール検知器の使用の有無</List.Header>
                                {`${data.is_alcohol_check === true ? '有' : '無'}`}
                                </List.Content>
                            </List.Item>
                            <List.Item>
                                <List.Content>
                                <List.Header style={{ marginBottom: '0.3em' }}>酒気帯びの有無</List.Header>
                                {`${data.is_shuki_obi === true ? '有' : '無'}`}
                                </List.Content>
                            </List.Item>
                            <List.Item>
                                <List.Content>
                                <List.Header style={{ marginBottom: '0.3em' }}>アルコールチェックの検査値</List.Header>
                                {`${data.alcohol_check_value}`} mg/L
                                </List.Content>
                            </List.Item>
                            <List.Item>
                                <List.Content>
                                <List.Header style={{ marginBottom: '0.3em' }}>走行距離計（運行後）</List.Header>
                                {`${data.unko_go_soko_kyori}`} km
                                </List.Content>
                            </List.Item>
                            <List.Item>
                                <List.Content>
                                <List.Header style={{ marginBottom: '0.3em' }}>当日の総走行距離</List.Header>
                                {`${data.so_soko_kyori}`} km
                                </List.Content>
                            </List.Item>
                            <List.Item>
                                <List.Content style={{ whiteSpace: 'pre-line' }}>
                                <List.Header style={{ marginBottom: '0.3em' }}>配送の記録（発着地住所・時間・走行距離・備考等）</List.Header>
                                {data.kiroku ? data.kiroku : <span style={{ visibility: 'hidden' }}>　</span>}
                                </List.Content>
                            </List.Item>
                            <List.Item>
                                <List.Content style={{ whiteSpace: 'pre-line' }}>
                                <List.Header style={{ marginBottom: '0.3em' }}>休憩・仮眠（時刻・場所等）</List.Header>
                                {data.kyukei ? data.kyukei : <span style={{ visibility: 'hidden' }}>　</span>}
                                </List.Content>
                            </List.Item>
                            <List.Item>
                                <List.Content style={{ whiteSpace: 'pre-line' }}>
                                <List.Header style={{ marginBottom: '0.3em' }}>自動車・道路及び運行の状況</List.Header>
                                {data.unko_jokyo ? data.unko_jokyo : <span style={{ visibility: 'hidden' }}>　</span>}
                                </List.Content>
                            </List.Item>
                            <List.Item>
                                <List.Content style={{ whiteSpace: 'pre-line' }}>
                                <List.Header style={{ marginBottom: '0.3em' }}>交替運転者に対する通告</List.Header>
                                {data.kotaisha_tsukoku ? data.kotaisha_tsukoku : <span style={{ visibility: 'hidden' }}>　</span>}
                                </List.Content>
                            </List.Item>
                            <List.Item>
                                <List.Content style={{ whiteSpace: 'pre-line' }}>
                                <List.Header style={{ marginBottom: '0.3em' }}>その他特記事項（指示事項等）</List.Header>
                                {data.sonota ? data.sonota : <span style={{ visibility: 'hidden' }}>　</span>}
                                </List.Content>
                            </List.Item>
                        </List>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Modal.Content>
        </Segment>
        <Modal.Actions>         
          <Button onClick={onClickCancel} content='閉じる' />
        </Modal.Actions>
      </Modal>
    </>
  )
}